import { Box, Modal, Typography } from "@mui/material";
import { Button } from "antd";
import React from "react";
import { handleExportExcel, handleExportPDF } from "../../Utils";

const CustomModal = ({
  modalVisible,
  handleClose,
  leftBtnPress,
  RightBtnPress,
  headingTxt,
  YesBtnText,
  NoBtnText,
}) => {
  const modalStyle = {
    flex: 1,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    borderRadius: "10px",
    p: 6,
  };

  const handleExcelExport = () => {
    handleExportExcel(leftBtnPress);
    handleClose();
  };

  const handlePDFExport = () => {
    handleExportPDF(RightBtnPress);
    handleClose();
  };
  return (
    <Modal
      keepMounted
      open={modalVisible}
      onClose={handleClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography
          id="keep-mounted-modal-title"
          variant="h6"
          component="h2"
          style={{ textAlign: "center" }}
        >
          {headingTxt}
        </Typography>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <Button variant="contained" onClick={handleExcelExport}>
            {YesBtnText}
          </Button>
          <Button variant="contained" onClick={handlePDFExport}>
            {NoBtnText}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default CustomModal;
